var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v2-profile-address"},[_c('v2-address-section',{attrs:{"addresses":_vm.addressComposable,"countries":_vm.countryList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }